const PROD = process.env.NODE_ENV === 'production';

const Environment = {
  API_URL: PROD ? 'https://others-maxximus-tecnologia-backend.pvuzyy.easypanel.host' : 'http://localhost:3001',
};

export default Environment;
